import { request } from './core'
import type { ResearchResponse } from './types'

/** Company-level web research. No If-Match: the server's guard compares
 *  against the ASSESSMENT revision, which a company-only caller doesn't have;
 *  the company write itself is optimistic-retry safe server-side. */
export const researchApi = {
  getResearch: (slug: string) =>
    request<ResearchResponse>(`/api/assessments/${slug}/research`),

  triggerResearch: (slug: string) =>
    request<{ status: string; revision?: number }>(`/api/assessments/${slug}/research`, {
      method: 'POST',
    }),

  acceptFinding: (slug: string, fieldPath: string) =>
    request<{ ok: boolean; revision?: number }>(
      `/api/assessments/${slug}/research/findings/${encodeURI(fieldPath)}/accept`,
      { method: 'POST' },
    ),

  /** Accept ALL pending findings in one atomic request. */
  acceptAllFindings: (slug: string) =>
    request<{ ok: boolean; applied: string[]; remaining: number; revision?: number }>(
      `/api/assessments/${slug}/research/findings/accept-all`,
      { method: 'POST' },
    ),

  rejectFinding: (slug: string, fieldPath: string) =>
    request<{ ok: boolean; revision?: number }>(
      `/api/assessments/${slug}/research/findings/${encodeURI(fieldPath)}/reject`,
      { method: 'POST' },
    ),
}
